import { MarketingCTA } from '@web/sections/CTA/MarketingCTA'
import { MarketingButton } from '../../components/MarketingButton'

const JobVacanciesCTA = () => {
  return (
    <MarketingCTA>
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-8 lg:flex-row lg:items-start lg:gap-12">
        {/* Heading - centered vertically with button */}
        <h1 className="text-center  font-light leading-tight tracking-tight text-text-inverted lg:text-left  lg:leading-tight text-h1Light ">
          Join Our Mission
        </h1>

        {/* Button - aligned to center on mobile, right on desktop */}
        <div className="shrink-0">
          <MarketingButton
            as="a"
            href="https://urbanintelligencegroup.bamboohr.com/careers"
            target="_blank"
            rel="noopener noreferrer"
            variant="secondary"
          >
            Vacancies
          </MarketingButton>
        </div>
      </div>
    </MarketingCTA>
  )
}

export default JobVacanciesCTA
